export default {
  props: {
    showPendingLink: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onDone() {
      this.$emit('done');
    },
    onViewPendingDeposits() {
      this.$router.push({ name: 'wallet', query: { tabId: 'pending', subTab: 'deposits' } });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/shared/deposit-done-links/deposit-done-links.js